var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavStreaming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.1027,
    cy: 10.3625,
    r: 3.635,
    stroke: "#BBC2CF",
    strokeWidth: 2.33
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4678 4.91406C21.4678 4.91406 23.6018 6.68419 23.6018 10.3244C23.6018 13.9646 21.4678 15.8109 21.4678 15.8109",
    stroke: "#BBC2CF",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.166 2.00781C25.166 2.00781 28.7336 4.74768 28.7336 10.1959C28.7336 15.8142 25.166 18.7174 25.166 18.7174",
    stroke: "#BBC2CF",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73828 4.91406C8.73828 4.91406 6.6043 6.68419 6.6043 10.3244C6.6043 13.9646 8.73828 15.8109 8.73828 15.8109",
    stroke: "#BBC2CF",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04004 2.00781C5.04004 2.00781 1.47246 4.74768 1.47246 10.1959C1.47246 15.8142 5.04004 18.7174 5.04004 18.7174",
    stroke: "#BBC2CF",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavStreaming);
export default __webpack_public_path__ + "static/media/nav-streaming.2e976ef25e6ab8652d767a0988bc98bc.svg";
export { ForwardRef as ReactComponent };